export enum PlatformTourYoutubeVideoID {
  LATAM = `85nTCz30UGs`,
  BR = `8Y40IeK3tRQ`,
}
